<img
  src="images/logo_name.svg"
  alt="ideastream.io Logo mit Text"
  class="logo"
  (click)="goBackHome()"
/>
<rr-btn
  type="Primary"
  size="small"
  iconStart="close"
  *ngIf="showHeaderBackButton === true"
  (btnclick)="goOnePageBack()"
  i18n
  >Close</rr-btn
>
<div class="sidebar row gap-16" *ngIf="showHeaderBackButton === false">
  <!-- <rr-icon class="help" name="help" (click)="gotoFaq()"></rr-icon> -->
  <!-- <rr-messages></rr-messages> -->
  <rr-usermenue></rr-usermenue>
</div>
